import Marquee from "react-fast-marquee";

const MarqueeCards = ({ children, direction }) => {
  return (
    <Marquee
      direction={direction}
      gradient={false}
      speed={110}
      pauseOnHover={true}
      // delay={10000}
    >
      {children}
    </Marquee>
  );
};

export default MarqueeCards;
